import React from 'react';
import step1 from '~/images/expertise/expertiseSteps/step1.svg';
import step2 from '~/images/expertise/expertiseSteps/step2.svg';
import step3 from '~/images/expertise/expertiseSteps/step3.svg';
import step4 from '~/images/expertise/expertiseSteps/step4.svg';
import step5 from '~/images/expertise/expertiseSteps/step5.svg';
import step6 from '~/images/expertise/expertiseSteps/step6.svg';
export const stepsContent = [
  {
    stepNum: '1',
    stepText: 'Open your patient case by submitting your patient’s information, clinical photos and dental impressions.',
    stepResult: 'CREATES CASE DATE',
    icon: <img src={step1} alt="icon creates case date"/>,
    key: 'step1'
  },
  {
    stepNum: '2',
    stepText: 'You will receive a notification once we have reviewed your patient case and updated the Doctor Portal.',
    stepResult: 'THE NEXT DAY',
    icon: <img src={step2} alt="icon the next date"/>,
    key: 'step2'
  },
  {
    stepNum: '3',
    stepText: 'We will create the preliminary cost estimate and plan for your patient case. A customized digital rendering is available upon request.',
    stepResult: 'DAY 3',
    icon: <img src={step3} alt="icon day 3"/>,
    key: 'step3'
  },
  {
    stepNum: '4',
    stepText: 'We begin creating the full treatment plan.',
    stepResult: 'DAY 5',
    icon: <img src={step4} alt="icon day 5"/>,
    key: 'step4'
  },
  {
    stepNum: '5',
    stepText: 'We will send you a message asking for approval of your patient’s treatment plan.',
    stepResult: 'DAY 8',
    icon: <img src={step5} alt="icon day 8"/>,
    key: 'step5'
  },
  {
    stepNum: '6',
    stepText: 'Orthosnap ships the first aligner of the approved treatment plan for you to verify the fit.',
    stepResult: 'DAY 14',
    icon: <img src={step6} alt="icon day 14"/>,
    key: 'step6'
  }
];
